// Copyright (c) Bentley Systems
export enum EfFieldValidationTypeEnum {
  Default = "Default",
  Xml = "Xml",
  Json = "Json",
  XmlOrJson = "XmlOrJson",
  GuidType = "GuidType",
  IntType = "IntType",
  Boolean = "Boolean",
  Email = "Email",
  Url = "Url",
  Datetime = "Datetime",
  Date = "Date",
  FloatType = "FloatType",
  Name100 = "Name100",
  Name200 = "Name200",
  Name150 = "Name150",
  UniqueName = "UniqueName",
  MqttClientId = "MqttClientId",
  MqttKey = "MqttKey",
  SystemId = "SystemId",
  Version = "Version",
  SearchString = "SearchString",
}
